/* eslint-disable jsx-a11y/media-has-caption */
import React, { ReactElement, useContext } from 'react';
import { t } from 'i18next';
import styled from 'styled-components';
import { screen } from '../../common/breakpoints';
import { TypoScale } from '../../common/spacings';
import { NeutralColors } from '../../common/colors';
import { GiveawayContext } from '../../services/GiveawayContextService';
import camflightPlaceholder from '../../assets/camera_flight_placeholder_s.png';

const StyledCameraFlightContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const StyledPlaceholderContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: black;
  width: inherit;
  text-align: center;

  img {
    width: 100%;
  }
`;

const StyledCameraFlight = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledVideo = styled.video`
  max-width: 100%;
  max-height: 100%;
`;

const StyledPlaceholderText = styled.h3`
  position: absolute;
  bottom: 15%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${NeutralColors.White};
  font-weight: 400;
  font-size: ${TypoScale.S};
  width: 100%;
  margin: 0 auto;

  @media screen and ${screen.m} {
    bottom: 25%;
    font-size: ${TypoScale.M};
  }

  @media screen and ${screen.l} {
    bottom: 30%;
    font-size: ${TypoScale.L};
  }

  @media screen and ${screen.xl} {
    bottom: 35%;
    font-size: ${TypoScale.XL};
  }

  @media screen and ${screen.xxl} {
    bottom: 40%;
    font-size: ${TypoScale.XL};
  }
`;

export const CameraFlight = (): ReactElement => {
  const giveawayResponse = useContext(GiveawayContext);
  const { renderCameraFlight, cameraFlightVideo } = giveawayResponse;

  if (!renderCameraFlight) {
    return <></>;
  }

  return cameraFlightVideo ? (
    <StyledCameraFlightContainer>
      <StyledCameraFlight>
        <StyledVideo controls data-testid="cameraflight-video">
          <source src={cameraFlightVideo} type="video/mp4" />
        </StyledVideo>
      </StyledCameraFlight>
    </StyledCameraFlightContainer>
  ) : (
    <StyledPlaceholderContainer>
      <img
        src={camflightPlaceholder}
        data-testid="cameraflight-placeholder"
        alt="cameraflight-placeholder"
      />
      <StyledPlaceholderText data-testid="cameraflight-placeholder-text">
        {t('giveaway.cameraFlightPlaceholder')}
      </StyledPlaceholderText>
    </StyledPlaceholderContainer>
  );
};
